import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=703ac872&"
import script from "./CardsView.vue?vue&type=script&lang=js&"
export * from "./CardsView.vue?vue&type=script&lang=js&"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=703ac872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/assets/images/logo/cachet senegal.png?vue&type=custom&index=0&blockType=img&issuerPath=%2Fapp%2Fsrc%2Fviews_moozimed%2Fcards%2FCardsView.vue&alt=vuexy-logo&style=width%3A%2040px%3B%20height%3A%2040px%3B%20object-fit%3A%20contain%3B"
if (typeof block0 === 'function') block0(component)

export default component.exports